import { render, staticRenderFns } from "./guanlianzhangdan.vue?vue&type=template&id=a0bcd630&scoped=true&"
import script from "./guanlianzhangdan.vue?vue&type=script&lang=js&"
export * from "./guanlianzhangdan.vue?vue&type=script&lang=js&"
import style0 from "./guanlianzhangdan.vue?vue&type=style&index=0&id=a0bcd630&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bcd630",
  null
  
)

export default component.exports